import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { Box, Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';
import FilterComponent from './FilterComponent';
import { fetchRescueSizesIfNeeded } from '../../../actions/rescueSizes';

const RescueSizeButton = ({ children, ...rest }) => (
  <ToggleButton
    sx={[
      {
        padding: 0,
        height: 55,
        minWidth: 50,
        '&.Mui-selected': {
          backgroundColor: 'primary.main',
          color: '#fff',
          '&:hover': {
            backgroundColor: 'primary.main',
          },
        },
        '& .MuiGrid-container': {
          marginLeft: '4px',
          marginRight: '4px',
        },
      },
    ]}
    {...rest}
  >
    {children}
  </ToggleButton>
);

export const getLabel = selectedDays => rescueSizesList => {
  const daysSelected = selectedDays.length;
  if (daysSelected === 0 || daysSelected === rescueSizesList.length) {
    return 'Vehicle Size: all';
  }

  return `Vehicle Size: ${selectedDays.length} selected`;
};

const RescueSizeFilter = ({ value, handleSizesChange }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [listValue, setListValue] = useState(value);
  const [lastSelectedRescueSize, setLastSelectedRescueSize] = useState();
  const rescueSizes = useSelector(state => state.entities.rescueSizes);
  const rescueSizesList = rescueSizes.sorted;
  useEffect(() => {
    dispatch(fetchRescueSizesIfNeeded());
  }, []);

  useEffect(() => {
    handleSizesChange(listValue);
  }, [listValue]);

  const handleVehicleSizeChange = (event, newValue) => {
    const buttonDataSet = event.currentTarget.closest('.size-button').dataset;
    const rescueSizeId = +buttonDataSet.sizeId;
    const rescueMealsPerRescue = +buttonDataSet.mealsPerRescue;

    // if user click twice on the same button, clear all values
    if (rescueSizeId === lastSelectedRescueSize || newValue.length === 0) {
      setLastSelectedRescueSize(+buttonDataSet.sizeId);
      return setListValue([]);
    }


    // check all options till last rescue size
    const newVals = rescueSizesList.reduce((acc, curr) => {
      if (curr.meals_per_rescue <= rescueMealsPerRescue) {
        acc.push(curr.id);
      }
      return acc;
    }, []);

    setLastSelectedRescueSize(+buttonDataSet.sizeId);
    return setListValue(newVals);
  };

  return (
    <>
      <ListItem button onClick={() => setIsOpen(!isOpen)}>
        <ListItemText primary={getLabel(listValue)(rescueSizesList)} />
        {isOpen ? <ExpandMore /> : <ExpandLess />}
      </ListItem>
      <FilterComponent isOpen={isOpen}>
        <Box
          py={2}
          px={4}
          display="flex"
          justifyContent="center"
          alignItems="center"
          direction="row"
          flexGrow={1}
          flexBasis={0}
        >
          <ToggleButtonGroup
            size="medium"
            orientation="vertical"
            value={value}
            onChange={handleVehicleSizeChange}
            aria-label="text alignment"
          >
            {rescueSizesList.map((size, index) => {
              const row = [];
              row.push(
                <RescueSizeButton
                  key={index}
                  value={size.id}
                  className="size-button"
                  data-meals-per-rescue={size.meals_per_rescue}
                  data-size-name={size.name}
                  data-size-id={size.id}
                >
                  <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid>{size.name}</Grid>
                  </Grid>
                </RescueSizeButton>
              );

              return row;
            })}
          </ToggleButtonGroup>
        </Box>
      </FilterComponent>
    </>
  );
};

export default RescueSizeFilter;
